import { Switch } from 'baby-design'
import css from './MustHave.style.scss'
import { RegItem } from 'src/types/regItem'

interface EditItemDetailsMustHaveSettingProps {
  regItemFields: RegItem
  updateRegItemFields: (changes: object) => void
}

export const EditItemDetailsMustHaveSetting = ({
  regItemFields,
  updateRegItemFields,
}: EditItemDetailsMustHaveSettingProps) => {
  const { isFavorite } = regItemFields

  return (
    <div className={css.must_have}>
      <div className={css.must_have__label} id="mustHaveLabel">
        <div className={css.must_have__heading}>Must Have</div>
        <div className={css.must_have__subheading}>
          Mark this item as most wanted.
        </div>
      </div>
      <Switch
        aria-labelledby="mustHaveLabel"
        checked={isFavorite}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          updateRegItemFields({ isFavorite: e.target.checked })
        }
      />
    </div>
  )
}
